module.exports = __webpack_public_path__ + "img/invision.f816761a.png";